import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SvgIconComponent } from 'angular-svg-icon';

import { FlatButtonComponent } from '../../shared/components/buttons/flat-button/flat-button.component';
import { IconButtonComponent } from '../../shared/components/buttons/icon-button/icon-button.component';

@Component({
  templateUrl: './updater.component.html',
  styleUrls: ['./updater.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FlatButtonComponent, IconButtonComponent, SvgIconComponent],
})
export class UpdaterComponent {
  private _snackBar = inject(MatSnackBar);

  public update(): void {
    document.location.reload();
  }

  public close(): void {
    this._snackBar._openedSnackBarRef?.dismiss();
  }
}
